"use strict";

/**
 * @module Services.Metrics
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeasuredEntityClassRequest = void 0;
/**
 * A request for entity metrics from a certain server of the cluster.
 */
var MeasuredEntityClassRequest = /** @class */function () {
  function MeasuredEntityClassRequest(entityClass, serverName) {
    this.entityClass = entityClass;
    this.serverName = serverName;
  }
  return MeasuredEntityClassRequest;
}();
exports.MeasuredEntityClassRequest = MeasuredEntityClassRequest;